<template>
    <v-card flat>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>

        <v-card-text v-else>
            <v-container>
                <v-row>
                    <v-col cols="12" md="2" class="text-center">
                        <div style="position: relative">
                            <v-avatar size="128" :color="(userCompany.profile.color) ? userCompany.profile.color : 'primary'" class="mb-2">
                                <img v-if="userCompany.profile.avatar !== undefined" :src="userCompany.profile.avatar.url" :alt="userCompany.user.name">
                                <span class="white--text headline" v-else>{{ userCompany.user.name | initialName }}</span>
                            </v-avatar>
                            <div v-show="userCompany.permissions.isAdmin" class="pt-2">
                                <h3>{{ $t('legalTeam.detail.fields.admin') }}</h3>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="10">
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="userCompany.user.name"
                                    :label="$t('legalTeam.detail.fields.name')"
                                    flat
                                    readonly
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="userCompany.user.username"
                                    :label="$t('legalTeam.detail.fields.email')"
                                    flat
                                    readonly
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="userCompany.profile.jobTitle"
                                    :label="$t('legalTeam.detail.fields.jobTitle')"
                                    flat
                                    readonly
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="userCompany.profile.phone"
                                    :label="$t('legalTeam.detail.fields.phone')"
                                    v-mask="['(##) ####-####', '(##) #####-####']"
                                    flat
                                    readonly
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="userCompany.activeDemands"
                                    :label="$t('legalTeam.detail.fields.activeDemands')"
                                    flat
                                    readonly
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="userCompany.demandsCompleted"
                                    :label="$t('legalTeam.detail.fields.demandsCompleted')"
                                    flat
                                    readonly
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="userCompany.workedHours"
                                    :label="$t('legalTeam.detail.fields.workedHours')"
                                    flat
                                    readonly
                                    disabled
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import API from '@/api'
import { mask } from 'vue-the-mask'

export default {
    name: 'detail-tab-staff',
    directives: {
        mask
    },
    data: function () {
        return {
            loading: true,
            userCompany: {
                user: undefined,
                client: undefined,
                profile: {
                    color: '#2980b9',
                    phone: undefined,
                    jobTitle: undefined
                },
                nameLowerCase: undefined,
                permissions: {
                    isAdmin: false
                }
            }
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        loadData () {
            this.loading = true
            let endpoint = API.EndPoints.getUserCompanyDetail
            endpoint.id = this.$route.params.id
            let params = {
                include: ['user']
            }
            new API(endpoint, params).request().then(response => {
                this.userCompany = { ...response.data }
                this.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        }
    }
}
</script>
